import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Checkbox, Container, FormLabel, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import appConfig from '../config';
import { getContractSettingsdata, updateContractSettings, uploadFile } from '../helper/backend_helper';
import InfoTooltip from '../components/InfoTooltip';

const ContractSettingsPage = () => {
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [liveImage, setLiveImage] = useState('');
  const [isWaterMarkAllowed, setIsWaterMarkAllowed] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log(liveImage);
  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];

    setImage(file);
    setImagePreview(URL.createObjectURL(file));
    // if (file) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     setImageBase64(reader.result);
    //   };
    //   reader.readAsDataURL(file);
    // }
  };

  const fetchSettings = async () => {
    try {
      const res = await getContractSettingsdata();
      const image = res?.data?.data?.waterMarkImage;
      setLiveImage(image);
      setIsWaterMarkAllowed(res?.data?.data?.isWaterMarkAllowed);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const data = new FormData();
      data.append('file', image);

      const imageResponse = await uploadFile(data, headers); // Assign value inside the block

      const submitData = {
        waterMarkImage: imageResponse?.data?.data?.fileName,
        isWaterMarkAllowed,
      };
      console.log(submitData);
      await updateContractSettings(submitData, {
        headers: { 'Content-Type': 'application/json' },
      });
      Swal.fire({
        icon: 'success',
        title: 'Image updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update image',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contract Settings</title>
      </Helmet>
      <Card sx={{ p: 3 }}>
        <Typography variant="h5" mb={2}>
          Water Mark Image
        </Typography>

        <Box>
          <FormLabel>Choose Image <InfoTooltip title="Upload the watermark image stamped onto generated contract documents." /></FormLabel>
          <input type="file" accept="image/*" onChange={handleImageUpload} />
          {console.log(appConfig.FILE_URL + liveImage)}

          <Box mt={2}>
            <img
              src={imagePreview || appConfig.FILE_URL + liveImage}
              alt="Preview"
              style={{ width: 200, borderRadius: 8 }}
            />
          </Box>
        </Box>

        <Box>
          <FormLabel>Allow Water Mark <InfoTooltip title="When enabled, the watermark image above is applied to generated contract documents." /></FormLabel>
          <Checkbox
            checked={isWaterMarkAllowed}
            onChange={(e) => {
              setIsWaterMarkAllowed(e.target.checked);
            }}
          />
        </Box>

        <LoadingButton
          sx={{ mt: 4, backgroundColor: '#1E3A5F', '&:hover': { backgroundColor: '#1E3A5F' } }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default ContractSettingsPage;
